import '@angular/compiler';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PageProjectsItemComponent } from './page.projects.item/page.projects.item.component';
import { PageAccountComponent } from './page.account/page.account.component';
import { PageProjectsGroupComponent } from './page.projects.group/page.projects.group.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageProjectsParticipatingGroupComponent } from './page.projects.participating.group/page.projects.participating.group.component';
import { PageProjectsFilebrowserComponent } from './page.projects.filebrowser/page.projects.filebrowser.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageProjectsMineGroupComponent } from './page.projects.mine.group/page.projects.mine.group.component';
import { ComponentUserActivityDashboardComponent } from './component.user.activity.dashboard/component.user.activity.dashboard.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageProjectsComponent } from './page.projects/page.projects.component';
import { ComponentReviewModalComponent } from './component.review.modal/component.review.modal.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageProjectsParticipatingComponent } from './page.projects.participating/page.projects.participating.component';
import { PageReviewsComponent } from './page.reviews/page.reviews.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { ComponentProjectFileActionsComponent } from './component.project.file.actions/component.project.file.actions.component';
import { PageProjectsMineComponent } from './page.projects.mine/page.projects.mine.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';

const INDEX_PAGE = "projects";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReviewOpsWorkspaceKeepaliveOutletComponent } from './workspace-keepalive-outlet';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "admin/:tab?",
                component: PageAdminComponent,
                "app_id": "page.admin"
            },
            {
                "path": "projects/:id/:tab?",
                component: PageProjectsItemComponent,
                "app_id": "page.projects.item"
            },
            {
                "path": "account",
                component: PageAccountComponent,
                "app_id": "page.account"
            },
            {
                "path": "projects/group/:group_id",
                component: PageProjectsGroupComponent,
                "app_id": "page.projects.group"
            },
            {
                "path": "projects/participating/group/:group_id",
                component: PageProjectsParticipatingGroupComponent,
                "app_id": "page.projects.participating.group"
            },
            {
                "path": "projects/mine/group/:group_id",
                component: PageProjectsMineGroupComponent,
                "app_id": "page.projects.mine.group"
            },
            {
                "path": "projects",
                component: PageProjectsComponent,
                "app_id": "page.projects"
            },
            {
                "path": "projects/participating",
                component: PageProjectsParticipatingComponent,
                "app_id": "page.projects.participating"
            },
            {
                "path": "reviews/:scope",
                component: PageReviewsComponent,
                "app_id": "page.reviews"
            },
            {
                "path": "projects/mine",
                component: PageProjectsMineComponent,
                "app_id": "page.projects.mine"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "project-file-browser/:id",
                component: PageProjectsFilebrowserComponent,
                "app_id": "page.projects.filebrowser"
            },
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            }
        ]
    }
];

let routeScore = (route: any) => {
    let path = route.path || "";
    let dynamicCount = (path.match(/:/g) || []).length;
    return dynamicCount * 1000 - path.length;
};

for (let i = 0; i < app_routes.length; i++) {
    app_routes[i].children = app_routes[i].children.sort((a: any, b: any) => routeScore(a) - routeScore(b));
}

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;
    let workspace_keepalive = layout_childs.some((child: any) => {
        return [
            'page.account',
            'page.admin',
            'page.projects',
            'page.projects.group',
            'page.projects.item',
            'page.projects.mine',
            'page.projects.mine.group',
            'page.projects.participating',
            'page.projects.participating.group',
            'page.reviews'
        ].indexOf(child.app_id) >= 0;
    });

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: workspace_keepalive ? ReviewOpsWorkspaceKeepaliveOutletComponent : child.component,
            data: workspace_keepalive ? {
                workspaceKeepalive: true,
                workspaceComponent: child.component,
                workspacePath: child.path,
                workspaceAppId: child.app_id || ''
            } : {}
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })], exports: [RouterModule] })
export class AppRoutingModule { }
